import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d399ca72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RolePermissionsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: `Список доступов роли '${_ctx.role.name}'`,
    "without-footer": "",
    onCancel: _ctx.emitClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.role.permissions, (permission, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: permission.id
          }, " (" + _toDisplayString(i + 1) + ") " + _toDisplayString(permission.name), 1))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title", "onCancel"]))
}